// extracted by mini-css-extract-plugin
export default {"root":"OverlayDisplay_root__nZWe4"};